"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.dropDownProperties = exports["default"] = void 0;

var _baseColors = _interopRequireDefault(require("../baseColors"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var dropdown = {
  status: {
    high: _baseColors["default"].vermilion,
    medium: _baseColors["default"].princetonOrange,
    low: _baseColors["default"].activeGreen,
    notApplicable: _baseColors["default"].archivedGrey
  }
};
var dropDownProperties = {
  textVerticalAlign: 'middle',
  borderOnHoverOnly: false,
  textTransform: 'uppercase'
};
exports.dropDownProperties = dropDownProperties;
var _default = dropdown;
exports["default"] = _default;